import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const UserSquare = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/user-square">
        <g id="user-square">
          <path
            id="Vector"
            d="M10.0004 15.1667H6.00042C5.12042 15.1667 4.38709 15.0801 3.76709 14.8934C3.54042 14.8267 3.39376 14.6067 3.40709 14.3734C3.57376 12.38 5.59376 10.8134 8.00042 10.8134C10.4071 10.8134 12.4204 12.3734 12.5938 14.3734C12.6138 14.6134 12.4671 14.8267 12.2338 14.8934C11.6138 15.0801 10.8804 15.1667 10.0004 15.1667ZM4.48042 14.04C4.92042 14.1267 5.42042 14.1667 6.00042 14.1667H10.0004C10.5804 14.1667 11.0804 14.1267 11.5204 14.04C11.1671 12.76 9.70709 11.8134 8.00042 11.8134C6.29376 11.8134 4.83376 12.76 4.48042 14.04Z"
          />
          <path
            id="Vector_2"
            d="M9.9987 1.33337H5.9987C2.66536 1.33337 1.33203 2.66671 1.33203 6.00004V10C1.33203 12.52 2.09203 13.9 3.90536 14.4134C4.05203 12.68 5.83203 11.3134 7.9987 11.3134C10.1654 11.3134 11.9454 12.68 12.092 14.4134C13.9054 13.9 14.6654 12.52 14.6654 10V6.00004C14.6654 2.66671 13.332 1.33337 9.9987 1.33337ZM7.9987 9.4467C6.6787 9.4467 5.61203 8.37339 5.61203 7.05339C5.61203 5.73339 6.6787 4.66671 7.9987 4.66671C9.3187 4.66671 10.3854 5.73339 10.3854 7.05339C10.3854 8.37339 9.3187 9.4467 7.9987 9.4467Z"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M7.99995 9.94661C6.40662 9.94661 5.11328 8.64664 5.11328 7.0533C5.11328 5.45997 6.40662 4.16663 7.99995 4.16663C9.59328 4.16663 10.8866 5.45997 10.8866 7.0533C10.8866 8.64664 9.59328 9.94661 7.99995 9.94661ZM7.99995 5.16663C6.95995 5.16663 6.11328 6.0133 6.11328 7.0533C6.11328 8.09997 6.95995 8.94661 7.99995 8.94661C9.03995 8.94661 9.88662 8.09997 9.88662 7.0533C9.88662 6.0133 9.03995 5.16663 7.99995 5.16663Z"
          />
        </g>
      </g>
    </svg>
  );
};

UserSquare.displayName = 'UserSquare';
